import {clearAllBodyScrollLocks, disableBodyScroll} from "body-scroll-lock/lib/bodyScrollLock.es6";

export default class ScrollHandler {
    constructor(backToTopSelector, backToTopOffset) {
        this.smoothScroll();
    }

    smoothScroll() {
        document.querySelectorAll('a[href^="#"]').forEach(anchor => {
            anchor.addEventListener('click', function(e) {
                e.preventDefault();
                let headerOffset = document.querySelector('.site-header').clientHeight;
                let element = document.querySelector(this.getAttribute('href'));
                let elementPosition = element.offsetTop;
                let offsetPosition = elementPosition - headerOffset;
                let tableOfContents = document.querySelector('.table-of-contents');

                if(tableOfContents){
                    offsetPosition = offsetPosition - tableOfContents.clientHeight;
                }

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
                });
                history.pushState({}, '', this.href);
            });
        });
    }

    static disableDocumentScroll(exception) {
        disableBodyScroll(exception);
        document.documentElement.style.overflow = 'hidden';
    }

    static enableDocumentScroll() {
        clearAllBodyScrollLocks();
        document.documentElement.style.overflow = '';
    }
}